import { marginY, mediaBreakpointOnly, mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import styled from 'styled-components';

const FormWrapper = styled.div`
  padding: ${remCalc(30)};

  ${mediaBreakpointUp('desktop')} {
    max-width: ${remCalc(360)};
  }
`;

const FormSubmittedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: ${remCalc(20)};

  > h2 {
    ${marginY(0)};
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: ${remCalc(20)};
  > div {
    row-gap: ${remCalc(10)};
  }
`;
const FormDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  && {
    row-gap: ${remCalc(20)};
  }

  > div {
    row-gap: ${remCalc(10)};
  }

  ${mediaBreakpointOnly('tablet')} {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: ${remCalc(20)};

    & > div {
      width: calc(50% - ${remCalc(10)});
    }
  }
`;

const FormHeadline = styled.h2`
  ${customTextSize(24, 34)}
  font-weight: ${FONT_WEIGHTS.MEDIUM};
  margin-bottom: ${remCalc(15)};

  ${mediaBreakpointUp('tablet')} {
    margin-bottom: ${remCalc(30)};
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 10px;
`;

const FormError = styled.div``;

const resourceFormComponents = {
  FormWrapper,
  FormSubmittedWrapper,
  Form,
  FormDetailsWrapper,
  FormHeadline,
  ButtonWrapper,
  FormError,
};

export default resourceFormComponents;
